// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/close.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/arrow-back.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/public/icons/filter.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/public/icons/card-style-list-mobile.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("/public/icons/card-style-tile-mobile.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("/public/icons/sort.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("/public/icons/select-checked.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*
! tailwindcss v3.4.7 | MIT License | https://tailwindcss.com
*/
/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/
*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}
::before,
::after {
  --tw-content: '';
}
/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/
html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}
/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/
body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}
/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/
hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}
/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/
abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}
/*
Remove the default font size and weight for headings.
*/
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}
/*
Reset links to optimize for opt-in styling instead of opt-out.
*/
a {
  color: inherit;
  text-decoration: inherit;
}
/*
Add the correct font weight in Edge and Safari.
*/
b,
strong {
  font-weight: bolder;
}
/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/
code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}
/*
Add the correct font size in all browsers.
*/
small {
  font-size: 80%;
}
/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/
table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}
/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/
button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}
/*
Remove the inheritance of text transform in Edge and Firefox.
*/
button,
select {
  text-transform: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/
button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}
/*
Use the modern Firefox focus style for all focusable elements.
*/
:-moz-focusring {
  outline: auto;
}
/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/
:-moz-ui-invalid {
  box-shadow: none;
}
/*
Add the correct vertical alignment in Chrome and Firefox.
*/
progress {
  vertical-align: baseline;
}
/*
Correct the cursor style of increment and decrement buttons in Safari.
*/
::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}
/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/
[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}
/*
Remove the inner padding in Chrome and Safari on macOS.
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/
::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}
/*
Add the correct display in Chrome and Safari.
*/
summary {
  display: list-item;
}
/*
Removes the default spacing and border for appropriate elements.
*/
blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}
fieldset {
  margin: 0;
  padding: 0;
}
legend {
  padding: 0;
}
ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}
/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}
/*
Prevent resizing textareas horizontally by default.
*/
textarea {
  resize: vertical;
}
/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/
input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}
/*
Set the default cursor for buttons.
*/
button,
[role="button"] {
  cursor: pointer;
}
/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}
/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/
img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}
/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/
img,
video {
  max-width: 100%;
  height: auto;
}
/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}
*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
.container{
  width: 100%;
}
@media (min-width: 375px){
  .container{
    max-width: 375px;
  }
}
@media (min-width: 768px){
  .container{
    max-width: 768px;
  }
}
@media (min-width: 1200px){
  .container{
    max-width: 1200px;
  }
}
@media (min-width: 1600px){
  .container{
    max-width: 1600px;
  }
}
.sr-only{
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none{
  pointer-events: none;
}
.visible{
  visibility: visible;
}
.static{
  position: static;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.sticky{
  position: sticky;
}
.-right-1{
  right: -0.25rem;
}
.-top-1{
  top: -0.25rem;
}
.bottom-0{
  bottom: 0px;
}
.bottom-1{
  bottom: 0.25rem;
}
.bottom-7{
  bottom: 1.75rem;
}
.left-0{
  left: 0px;
}
.left-\\[20px\\]{
  left: 20px;
}
.right-0{
  right: 0px;
}
.right-1{
  right: 0.25rem;
}
.right-1\\/2{
  right: 50%;
}
.right-2\\.5{
  right: 0.625rem;
}
.right-5{
  right: 1.25rem;
}
.top-\\[-9px\\]{
  top: -9px;
}
.top-\\[6px\\]{
  top: 6px;
}
.z-10{
  z-index: 10;
}
.z-\\[3\\]{
  z-index: 3;
}
.m-0{
  margin: 0px;
}
.m-auto{
  margin: auto;
}
.mx-2{
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mb-14{
  margin-bottom: 3.5rem;
}
.mb-\\[30px\\]{
  margin-bottom: 30px;
}
.mr-1{
  margin-right: 0.25rem;
}
.mt-0\\.5{
  margin-top: 0.125rem;
}
.mt-4{
  margin-top: 1rem;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.table{
  display: table;
}
.grid{
  display: grid;
}
.hidden{
  display: none;
}
.h-4{
  height: 1rem;
}
.h-5{
  height: 1.25rem;
}
.h-6{
  height: 1.5rem;
}
.h-8{
  height: 2rem;
}
.h-\\[1\\.5px\\]{
  height: 1.5px;
}
.h-\\[118px\\]{
  height: 118px;
}
.h-\\[15px\\]{
  height: 15px;
}
.h-\\[18px\\]{
  height: 18px;
}
.h-\\[30px\\]{
  height: 30px;
}
.h-\\[46px\\]{
  height: 46px;
}
.h-\\[70vh\\]{
  height: 70vh;
}
.h-\\[80vh\\]{
  height: 80vh;
}
.h-full{
  height: 100%;
}
.h-px{
  height: 1px;
}
.max-h-\\[0px\\]{
  max-height: 0px;
}
.max-h-\\[160px\\]{
  max-height: 160px;
}
.max-h-\\[394px\\]{
  max-height: 394px;
}
.max-h-\\[80px\\]{
  max-height: 80px;
}
.min-h-\\[20px\\]{
  min-height: 20px;
}
.w-11{
  width: 2.75rem;
}
.w-2{
  width: 0.5rem;
}
.w-24{
  width: 6rem;
}
.w-4{
  width: 1rem;
}
.w-5{
  width: 1.25rem;
}
.w-6{
  width: 1.5rem;
}
.w-8{
  width: 2rem;
}
.w-\\[118px\\]{
  width: 118px;
}
.w-\\[15px\\]{
  width: 15px;
}
.w-\\[18px\\]{
  width: 18px;
}
.w-\\[205px\\]{
  width: 205px;
}
.w-\\[30px\\]{
  width: 30px;
}
.w-\\[46px\\]{
  width: 46px;
}
.w-\\[calc\\(100\\%-50px\\)\\]{
  width: calc(100% - 50px);
}
.w-fit{
  width: fit-content;
}
.w-full{
  width: 100%;
}
.min-w-\\[1rem\\]{
  min-width: 1rem;
}
.min-w-\\[205px\\]{
  min-width: 205px;
}
.min-w-\\[220px\\]{
  min-width: 220px;
}
.flex-1{
  flex: 1 1;
}
.flex-grow{
  flex-grow: 1;
}
.-translate-x-0{
  --tw-translate-x: -0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-1\\/2{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-0{
  --tw-translate-y: -0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-1{
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-6{
  --tw-translate-x: 1.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-0{
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90{
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-0{
  --tw-scale-x: 0;
  --tw-scale-y: 0;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-100{
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-95{
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.cursor-auto{
  cursor: auto;
}
.cursor-pointer{
  cursor: pointer;
}
.select-none{
  -webkit-user-select: none;
          user-select: none;
}
.resize-none{
  resize: none;
}
.resize{
  resize: both;
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.flex-row{
  flex-direction: row;
}
.flex-col{
  flex-direction: column;
}
.flex-wrap{
  flex-wrap: wrap;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.items-stretch{
  align-items: stretch;
}
.justify-start{
  justify-content: flex-start;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.gap-1{
  gap: 0.25rem;
}
.gap-1\\.5{
  gap: 0.375rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-2\\.5{
  gap: 0.625rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-4{
  gap: 1rem;
}
.gap-5{
  gap: 1.25rem;
}
.gap-6{
  gap: 1.5rem;
}
.gap-8{
  gap: 2rem;
}
.gap-\\[11px\\]{
  gap: 11px;
}
.gap-\\[15px\\]{
  gap: 15px;
}
.gap-\\[16px\\]{
  gap: 16px;
}
.gap-\\[30px\\]{
  gap: 30px;
}
.gap-\\[5px\\]{
  gap: 5px;
}
.gap-\\[9px\\]{
  gap: 9px;
}
.gap-x-2\\.5{
  column-gap: 0.625rem;
}
.self-end{
  align-self: flex-end;
}
.self-center{
  align-self: center;
}
.overflow-auto{
  overflow: auto;
}
.overflow-hidden{
  overflow: hidden;
}
.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.whitespace-pre-wrap{
  white-space: pre-wrap;
}
.rounded-\\[4px\\]{
  border-radius: 4px;
}
.rounded-\\[5px\\]{
  border-radius: 5px;
}
.rounded-\\[7\\.5px\\]{
  border-radius: 7.5px;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-md{
  border-radius: 0.375rem;
}
.rounded-sm{
  border-radius: 0.125rem;
}
.border{
  border-width: 1px;
}
.border-0{
  border-width: 0px;
}
.border-2{
  border-width: 2px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-t{
  border-top-width: 1px;
}
.border-\\[\\#E9E8E8\\]{
  --tw-border-opacity: 1;
  border-color: rgb(233 232 232 / var(--tw-border-opacity));
}
.border-\\[\\#F2F2F2\\]{
  --tw-border-opacity: 1;
  border-color: rgb(242 242 242 / var(--tw-border-opacity));
}
.border-black{
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}
.border-gray-30{
  --tw-border-opacity: 1;
  border-color: rgb(237 237 237 / var(--tw-border-opacity));
}
.border-gray-900\\/50{
  border-color: rgb(17 24 39 / 0.5);
}
.border-primary{
  border-color: var(--color-primary);
}
.border-white\\/20{
  border-color: rgb(255 255 255 / 0.2);
}
.border-opacity-10{
  --tw-border-opacity: 0.1;
}
.bg-\\[\\#444654\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(68 70 84 / var(--tw-bg-opacity));
}
.bg-\\[var\\(--color-primary-bg\\)\\]{
  background-color: var(--color-primary-bg);
}
.bg-b-primary{
  background-color: var(--color-primary);
}
.bg-black{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.bg-gray-20{
  --tw-bg-opacity: 1;
  background-color: rgb(248 248 248 / var(--tw-bg-opacity));
}
.bg-gray-50{
  --tw-bg-opacity: 1;
  background-color: rgb(194 194 194 / var(--tw-bg-opacity));
}
.bg-gray-700{
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity));
}
.bg-gray-800{
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity));
}
.bg-primary{
  background-color: var(--color-primary);
}
.bg-transparent{
  background-color: transparent;
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-opacity-60{
  --tw-bg-opacity: 0.6;
}
.bg-opacity-\\[0\\.02\\]{
  --tw-bg-opacity: 0.02;
}
.fill-gray-80{
  fill: #616161;
}
.fill-primary{
  fill: var(--color-primary);
}
.stroke-gray-80{
  stroke: #616161;
}
.p-0{
  padding: 0px;
}
.p-1{
  padding: 0.25rem;
}
.p-4{
  padding: 1rem;
}
.p-\\[2px\\]{
  padding: 2px;
}
.px-2\\.5{
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-\\[13\\.5px\\]{
  padding-left: 13.5px;
  padding-right: 13.5px;
}
.py-10{
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5{
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-\\[13px\\]{
  padding-top: 13px;
  padding-bottom: 13px;
}
.pb-4{
  padding-bottom: 1rem;
}
.pb-\\[18px\\]{
  padding-bottom: 18px;
}
.pl-2{
  padding-left: 0.5rem;
}
.pl-2\\.5{
  padding-left: 0.625rem;
}
.pl-9{
  padding-left: 2.25rem;
}
.pl-\\[27px\\]{
  padding-left: 27px;
}
.pr-2\\.5{
  padding-right: 0.625rem;
}
.pr-7{
  padding-right: 1.75rem;
}
.pr-\\[30px\\]{
  padding-right: 30px;
}
.pt-10{
  padding-top: 2.5rem;
}
.pt-2{
  padding-top: 0.5rem;
}
.pt-\\[30px\\]{
  padding-top: 30px;
}
.pt-\\[342px\\]{
  padding-top: 342px;
}
.pt-\\[9px\\]{
  padding-top: 9px;
}
.text-3xl{
  font-size: 26px;
  line-height: 34px;
}
.text-3xl_m{
  font-size: 22px;
  line-height: 27px;
}
.text-\\[14px\\]{
  font-size: 14px;
}
.text-lg{
  font-size: 14px;
  line-height: 17px;
}
.text-md{
  font-size: 13px;
  line-height: 16px;
}
.text-sm{
  font-size: 12px;
  line-height: 15px;
}
.text-xs{
  font-size: 10px;
  line-height: 12px;
}
.text-xs-mini{
  font-size: 8px;
  line-height: 10px;
}
.font-bold{
  font-weight: 700;
}
.uppercase{
  text-transform: uppercase;
}
.leading-\\[160\\%\\]{
  line-height: 160%;
}
.text-\\[\\#757575\\]{
  --tw-text-opacity: 1;
  color: rgb(117 117 117 / var(--tw-text-opacity));
}
.text-black{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.text-gray-100{
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity));
}
.text-gray-30{
  --tw-text-opacity: 1;
  color: rgb(237 237 237 / var(--tw-text-opacity));
}
.text-gray-500{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}
.text-gray-60{
  --tw-text-opacity: 1;
  color: rgb(158 158 158 / var(--tw-text-opacity));
}
.text-gray-80{
  --tw-text-opacity: 1;
  color: rgb(97 97 97 / var(--tw-text-opacity));
}
.text-primary{
  color: var(--color-primary);
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.text-opacity-60{
  --tw-text-opacity: 0.6;
}
.text-opacity-80{
  --tw-text-opacity: 0.8;
}
.opacity-0{
  opacity: 0;
}
.opacity-100{
  opacity: 1;
}
.opacity-30{
  opacity: 0.3;
}
.shadow-\\[0_0_15px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.10\\)\\]{
  --tw-shadow: 0 0 15px rgba(0,0,0,0.10);
  --tw-shadow-colored: 0 0 15px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline{
  outline-style: solid;
}
.blur{
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.\\!transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter !important;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter !important;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.\\!duration-250{
  transition-duration: 250ms !important;
}
.duration-250{
  transition-duration: 250ms;
}
.duration-300{
  transition-duration: 300ms;
}
.duration-500{
  transition-duration: 500ms;
}
.duration-75{
  transition-duration: 75ms;
}
.duration-750{
  transition-duration: 750ms;
}
.ease-in{
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.ease-out{
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.will-change-transform{
  will-change: transform;
}
/*------------------------------RESET DEFAULT STYLES--------------------------------*/
html,
body {
  width: 100%;
  height: 100%;
}

body {
  overflow-x: hidden;
}

#root {
  font-family: Inter, sans-serif;
  color: #000000;
  background: #FFFFFF;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  padding-bottom: 50px;
}
@media only screen and (min-width: 768px) {
  #root {
    padding-bottom: 64px;
  }
}
@media only screen and (min-width: 1200px) {
  #root {
    padding-bottom: 0;
  }
}

body {
  padding: 0;
  margin: 0;
  line-height: 1.5;
  background: #fff;
}

div,
p,
a,
span,
em,
strong,
img,
h1,
h2,
h3,
h4,
h5,
h6,
ul,
ol,
li,
dl,
dt,
dd,
table,
td,
tr,
form,
fieldset,
label,
select,
input,
textarea,
header,
nav,
section,
article,
aside,
footer,
blockquote {
  padding: 0;
  margin: 0;
  outline: none;
  list-style: none;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}

header,
nav,
section,
article,
aside,
footer {
  display: block;
}

select,
input,
textarea {
  vertical-align: middle;
}

textarea {
  vertical-align: top;
  resize: none;
}

:focus {
  outline: none;
}

input[type=submit],
button {
  cursor: pointer;
}

img,
fieldset {
  border: 0;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

a {
  text-decoration: none;
}

a:hover {
  text-decoration: none;
}

::-webkit-scrollbar {
  width: 7px;
  height: 3px;
}

::-webkit-scrollbar-thumb {
  border-radius: 1000px;
  background: #b8b7b7;
}

@media only screen and (max-width: 1100px) {
  button,
  textarea,
  input,
  select,
  a,
  div,
  span {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-tap-highlight-color: transparent;
    -webkit-user-select: none;
    user-select: none;
  }
}
/*-----------------------------RESET DEFAULT STYLES END------------------------------*/
h1::selection,
h2::selection,
h3::selection,
p::selection,
li::selection,
a::selection,
strong::selection,
span::selection,
blockquote::selection,
img::selection,
address::selection {
  color: #fff;
  background: var(--color-primary);
  /* Цвет фона */
}

.dialog-filter {
  filter: drop-shadow(0px 2px 6px rgba(0, 0, 0, 0.04));
}

.apartment-card-filter {
  filter: drop-shadow(0px 4px 20px rgba(45, 46, 48, 0.1));
}

.bar {
  height: 4px !important;
  background: var(--color-primary) !important;
}

.spinner-icon {
  border-top-color: var(--color-primary) !important;
  border-left-color: var(--color-primary) !important;
}

.nspinner {
  width: 24px;
  height: 24px;
  box-sizing: border-box;
  border: solid 2px transparent;
  border-top-color: #29d;
  border-left-color: #29d;
  border-radius: 50%;
  animation: nprogress-spinner 400ms linear infinite;
  border-top-color: var(--color-primary);
  border-left-color: var(--color-primary);
}

.chakra-alert {
  background: #000000 !important;
}

.close-btn {
  width: 55px;
  height: 55px;
  border-radius: 50%;
  background-color: var(--color-primary);
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-btn::after {
  content: "";
  width: 12px;
  height: 12px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  position: absolute;
  transition: transform 0.3s;
}

.close-btn:hover::after {
  transform: rotate(90deg);
}

.flat-page-3d .flat-card-right-sidebar {
  border-color: transparent;
}
.flat-page-3d .button-3d-home-control {
  background-color: #000;
}

.rounded-btn {
  border: none;
  background: none;
  outline: none;
  padding: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f7fafd;
  border: 1px solid var(--color-primary);
  position: relative;
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;
  -webkit-user-select: none;
  user-select: none;
}
@media only screen and (min-width: 768px) {
  .rounded-btn {
    width: 55px;
    height: 55px;
  }
}
@media only screen and (min-width: 1200px) {
  .rounded-btn {
    width: 50px;
    height: 50px;
  }
}
@media only screen and (min-width: 1600px) {
  .rounded-btn {
    width: 55px;
    height: 55px;
  }
}
.rounded-btn.primary-color {
  background-color: var(--color-primary);
  border: 1px solid #e3ecf5;
}
.rounded-btn.white-color {
  background-color: #fff;
}
.rounded-btn img {
  display: block;
  max-width: 100%;
  object-fit: contain;
}
.rounded-btn svg path {
  transition: fill 0.25s, stroke 0.25s;
}
@media only screen and (min-width: 1200px) {
  .rounded-btn {
    transition: border-color 0.3s;
  }
  .rounded-btn:hover {
    border-color: #d0dce8;
  }
  .rounded-btn.primary-color {
    transition: background 0.3s, border-color 0.3s;
  }
  .rounded-btn.primary-color:hover {
    background: var(--color-primary-hover);
    border-color: var(--color-primary-hover);
  }
}
.rounded-btn.active > svg {
  fill: var(--color-primary);
}
.rounded-btn.active > svg path {
  fill: var(--color-primary);
  stroke: var(--color-primary);
}
.rounded-btn.no-border {
  border: 1px solid white !important;
}

.main-btn {
  border: none;
  background: none;
  outline: none;
  padding: 0;
  border: 1px solid #e9e8e8;
  display: flex;
  align-items: center;
  cursor: pointer;
  justify-content: center;
  gap: 10px;
  border-radius: 1000px;
  padding: 18px;
  min-width: 150px;
  font-weight: 500;
  font-size: 14px;
  line-height: 100%;
  color: #000;
  background: var(--color-primary-bg);
  text-align: center;
}
.main-btn.primary-color {
  background: var(--color-primary);
  color: #fff;
  border: 1px solid var(--color-primary);
}
@media only screen and (min-width: 1200px) {
  .main-btn {
    padding: 20.5px;
    min-width: 175px;
    transition: border-color 0.3s;
  }
  .main-btn:hover {
    border-color: #c2c2c2;
  }
  .main-btn.primary-color {
    transition: background 0.3s, border-color 0.3s;
  }
  .main-btn.primary-color:hover {
    background: var(--color-primary-hover) !important;
    border-color: var(--color-primary-hover) !important;
  }
}

.text p {
  margin: 0 0 20px 0;
}
.text p:first-of-type {
  margin: 0 0 20px 0;
}
.text p:last-child {
  margin: 0;
}
.text strong {
  font-weight: 500;
}
.text ul {
  margin-bottom: 50px;
}
.text ul li {
  position: relative;
  padding-left: 35px;
}
.text ul li::before {
  content: "";
  width: 8px;
  height: 8px;
  background-color: var(--color-primary);
  position: absolute;
  top: 10px;
  left: 0;
}
.text ul li:not(:last-child) {
  margin-bottom: 20px;
}
.text ol {
  padding-left: 32px;
  margin-bottom: 50px;
}
.text ol li {
  list-style-type: decimal;
}
.text ol li:not(:last-child) {
  margin-bottom: 16px;
}
.text a {
  color: #000;
  text-decoration: underline;
}
.fade-enter {
  opacity: 0;
}

.fade-enter-active {
  opacity: 1;
  transition: opacity 500ms;
}

.fade-exit {
  opacity: 1;
}

.fade-exit-active {
  opacity: 0;
  transition: opacity 500ms;
}

.input-position {
  width: 50%;
  position: relative;
}

.rc-slider-track {
  background: #1edc94 !important;
  transition: 0.5s;
}

.rc-slider-handle {
  background-color: white !important;
  transition: 0.5s;
}

.ant-checkbox-wrapper {
  display: flex;
}

.page-filter {
  display: flex;
  gap: 50px;
}

.visual .control-button-card {
  display: none;
}

.flat-page .filter-control-panel-3d {
  display: none;
}

.additional_filter {
  display: grid;
  grid-template-columns: repeat(2, auto);
  gap: 8px;
}

.house-3d-preview {
  display: flex;
  position: relative;
}
.house-3d-preview .control-3d {
  bottom: 10px;
  position: absolute;
}
.house-3d-preview .control-3d button,
.house-3d-preview .control-3d > div {
  width: 25px;
  height: 25px;
}
.house-3d-preview .control-3d svg {
  width: 10px;
}

.modal-3d-antd .ant-modal-content {
  padding: 0;
}

.house-3d-preview-button {
  position: absolute;
  right: 20px;
  cursor: pointer;
  bottom: 10px;
  background-color: var(--color-primary);
  border-radius: 50%;
  padding: 10px;
  transition: 0.3s;
}
.house-3d-preview-button:hover {
  transform: scale(1.1);
  background-color: #000000;
}
.house-3d-preview-button svg path {
  stroke: #fff;
  fill: #fff;
}

.page-filter__left {
  min-width: 410px;
  max-width: 410px;
  position: sticky;
  display: none;
  top: 100px;
  left: 30px;
  height: calc(100vh - 90px);
  padding-bottom: 50px;
}
.page-filter__left > div {
  width: 100%;
}
@media only screen and (min-width: 1200px) {
  .page-filter__left {
    display: block;
  }
}
@media only screen and (min-width: 1600px) {
  .page-filter__left {
    padding-top: 20px;
  }
}

.slider-filter {
  color: var(--color-primary) !important;
  height: 1px !important;
}
.slider-filter .MuiSlider-thumb {
  width: 16px;
  height: 16px;
}

.wrapper_slider {
  display: flex;
  gap: 20px;
}
.wrapper_slider > div {
  width: 95px;
  height: fit-content;
}

.modal-filter .page-filter {
  display: block;
}
.modal-filter .go_to_visual {
  display: none;
}
.modal-filter .filter-page-dev-field {
  display: flex;
}
.modal-filter .filter-page__select-sort {
  display: none;
}
.modal-filter .filter-page__flat-card {
  flex-direction: row;
}
.modal-filter .filter-page__flat-card img {
  width: 91px;
  height: 91px;
  object-fit: cover;
}
.modal-filter .filter-page__switch-mode {
  display: none;
}
.modal-filter .page-filter__left {
  max-width: auto;
  min-width: auto;
  position: static;
  height: auto;
  padding-bottom: 20px;
}
.modal-filter .MuiSlider-root {
  margin-left: 20px;
  margin-right: 20px;
}
.modal-filter .filter-apartaments-list {
  display: flex;
  flex-direction: column;
}
.modal-filter .wrapperAdv {
  display: none;
}

.page-filter-mobile {
  padding: 20px;
  height: 100%;
}

.rotate-image-container {
  position: relative;
}

.rotating-image {
  transition: opacity 0.5s ease-in-out;
}

.image-container {
  display: flex;
}

.image-slider {
  position: relative;
}
.image-slider button {
  background-color: red;
}

.image-slider-svg {
  position: absolute;
  left: 0;
  top: 0;
}

.slider-3d-control {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
}

g {
  cursor: pointer;
  opacity: 0;
  pointer-events: visibleFill;
}
g:hover, g.active {
  stroke: #fff;
  opacity: 0.7;
}

.ant-popover-inner {
  border-radius: 4px !important;
}

.image-slider__image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.popup-info-flat {
  width: 300px;
  display: flex;
  justify-items: center;
  flex-direction: column;
}
.popup-info-flat > div {
  flex-direction: row-reverse;
}
.popup-info-flat ul {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 5px;
}
.popup-info-flat ul li p:last-child {
  font-weight: bold;
}
.button-back-flat {
  display: flex;
  align-items: center;
  font-size: 12px;
  z-index: 10000;
  position: absolute;
  transition: 0.3s;
  top: -9px;
  right: 21px;
}
.button-back-flat:hover {
  color: var(--color-primary);
}
.button-back-flat button {
  width: 35px;
  height: 35px;
  margin-right: 15px;
}

.popup-info-master-plan {
  display: none;
  padding: 15px 25px;
  border-radius: 5px;
  background: var(--color-primary);
  color: white;
  position: absolute;
  font-size: 14px;
  position: fixed;
  width: 200px;
  top: 50%;
  z-index: 1;
  left: 50%;
}
.popup-info-master-plan__block {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 0;
}
.popup-info-master-plan__number {
  font-size: 35px;
  line-height: 1;
  font-weight: 500;
}
.popup-info-master-plan > div > div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 0;
}
.popup-info-master-plan__floor {
  display: block;
  border-bottom: 1px solid rgba(183, 216, 250, 0.2);
  padding-bottom: 12px;
}
.popup-info-master-plan__deadline {
  color: #b7d8fa;
  font-size: 12px;
}

.popup-info-master-plan__mobile {
  width: 80vw;
  position: absolute !important;
  left: 50% !important;
  top: 50% !important;
  transform: translate(-50%, -50%);
}

.ant-input-number-input {
  text-align: center !important;
  padding: 8px 10px;
  background: #f7fafd !important;
}

.ant-input-number-input-wrap {
  border-color: #e3ecf5 !important;
}

.filter-control-label {
  color: #757575;
  margin-top: 20px;
  margin-bottom: 10px;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 100%; /* 13px */
}

.ant-checkbox {
  border-radius: 3px !important;
}

.ant-checkbox-inner {
  border-color: #000 !important;
}

.ant-checkbox + span {
  padding-inline-start: 7px;
  padding-inline-end: 13px;
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 100%; /* 13px */
}

.filter-control-rooms .ant-checkbox + span {
  text-transform: lowercase;
}

.MuiSlider-rail {
  background-color: #e3ecf5 !important;
  opacity: 1 !important;
}

.MuiSlider-track {
  border: none !important;
}

.ant-checkbox-checked .ant-checkbox-inner {
  background-color: var(--color-primary) !important;
  border-color: var(--color-primary) !important;
}

.ant-radio-checked .ant-radio-inner {
  background-color: var(--color-primary) !important;
  border-color: var(--color-primary) !important;
}

.ant-checkbox-disabled .ant-checkbox-inner {
  border-color: #e2e8f0 !important;
}

.MuiSlider-valueLabel {
  background-color: var(--color-primary) !important;
}

.filter-status {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  border-bottom: 1px solid #e3ecf5;
  padding-bottom: 10px;
}
.filter-status p {
  color: #757575;
}
.filter-status b {
  color: #000;
  font-weight: 500;
  margin-left: 5px;
  text-transform: lowercase;
}

.filter-page__reset-button {
  display: flex;
  color: #757575;
  transition: 0.25s;
  align-items: center;
}
.filter-page__reset-button::before {
  content: "";
  display: block;
  width: 25px;
  height: 25px;
  margin-right: 5px;
  border-radius: 50%;
  border: 1px solid #e3ecf5;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center;
}
.filter-page__reset-button:hover {
  color: #000;
}

.filter-wrapper-price .wrapper_slider {
  flex-wrap: wrap;
}
.filter-wrapper-price .wrapper_slider > div {
  flex-grow: 1;
}
.filter-wrapper-price .MuiSlider-root {
  order: -1;
  margin: 0 10px;
}

.ant-input-number-affix-wrapper {
  background-color: #f7fafd;
  position: relative;
}

.ant-input-number-prefix {
  position: absolute;
  left: 10px;
  top: 50%;
  z-index: 1;
  transform: translateY(-50%);
  font-size: 13px;
  color: #757575;
}

.ant-input-number .ant-input-number-input {
  padding: 3px;
}

.additional_filter__wrapper .filter-control-label {
  color: #000;
  width: 100%;
  text-align: left;
}
.additional_filter__wrapper button {
  margin-bottom: 14px;
}
.additional_filter__wrapper button[aria-expanded=true] {
  border-bottom: 1px solid #e3ecf5;
}

.ant-checkbox-inner:after {
  background-color: var(--color-primary) !important;
}

.house-3d-popover-action {
  margin-right: auto;
}

svg image {
  pointer-events: visibleFill;
}

.filter-page__list-mode {
  display: flex;
  gap: 15px;
}

html,
body {
  overscroll-behavior-x: contain;
}

.ant-radio-wrapper,
.ant-radio-wrapper:hover .ant-radio-inner,
.ant-input-number:focus,
.ant-input-number:focus-within {
  border-color: var(--color-primary);
}

.ant-input-number:hover {
  border-color: var(--color-primary);
}

.ant-input-number-affix-wrapper:hover,
.ant-input-number-affix-wrapper:focus-within {
  border-color: var(--color-primary);
}

.button-clean {
  border: none;
}

.filter-page-house-dropdown {
  background-color: #fff;
  width: 100%;
  padding: 10px 0;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}

.filter-page-house-select {
  margin-top: 15px;
}
.filter-page-house-select__title {
  display: block;
}
.filter-page-house-select button {
  width: 100%;
  text-align: left;
  white-space: nowrap !important; /* Текст не переносится */
  overflow: hidden; /* Обрезаем всё за пределами блока */
  text-overflow: ellipsis !important; /* Добавляем многоточие */
}
.filter-page-house-select button span {
  display: inline !important;
}

.ant-btn-default:not(:disabled):not(.ant-btn-disabled):hover {
  color: var(--color-primary) !important;
  border-color: var(--color-primary) !important;
}

.svg-polygon-rooms-1 {
  fill: var(--type_1_bg_color_static);
  stroke: var(--type_1_color_stroke_static);
}
.svg-polygon-rooms-1:hover {
  fill: var(--type_1_bg_color_hover);
  stroke: var(--type_1_color_stroke_hover);
}

.svg-polygon-rooms-2 {
  fill: var(--type_2_bg_color_static);
  stroke: var(--type_2_color_stroke_static);
}
.svg-polygon-rooms-2:hover {
  fill: var(--type_2_bg_color_hover);
  stroke: var(--type_2_color_stroke_hover);
}

.svg-polygon-rooms-3 {
  fill: var(--type_3_bg_color_static);
  stroke: var(--type_3_color_stroke_static);
}
.svg-polygon-rooms-3:hover {
  fill: var(--type_3_bg_color_hover);
  stroke: var(--type_3_color_stroke_hover);
}

.svg-polygon-rooms-4 {
  fill: var(--type_4_bg_color_static);
  stroke: var(--type_4_color_stroke_static);
}
.svg-polygon-rooms-4:hover {
  fill: var(--type_4_bg_color_hover);
  stroke: var(--type_4_color_stroke_hover);
}

.svg-polygon-rooms-penthouse {
  fill: var(--type_penthouse_bg_color_static);
  stroke: var(--type_penthouse_color_stroke_static);
}
.svg-polygon-rooms-penthouse:hover {
  fill: var(--type_penthouse_bg_color_hover);
  stroke: var(--type_penthouse4_color_stroke_hover);
}

.svg-polygon-rooms-studio {
  fill: var(--type_studio_bg_color_static);
  stroke: var(--type_studio_color_stroke_static);
}
.svg-polygon-rooms-studio:hover {
  fill: var(--type_studio_bg_color_hover);
  stroke: var(--type_studio_color_stroke_hover);
}

.floor-builder-title {
  font-size: 14px;
}

.ant-checkbox .ant-checkbox-input:focus-visible + .ant-checkbox-inner {
  outline-color: transparent;
}

.placeholder\\:text-md::placeholder{
  font-size: 13px;
  line-height: 16px;
}

.placeholder\\:text-gray-40::placeholder{
  --tw-text-opacity: 1;
  color: rgb(224 224 224 / var(--tw-text-opacity));
}

.before\\:content-filter::before{
  --tw-content: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  content: var(--tw-content);
}

.after\\:pl-4::after{
  content: var(--tw-content);
  padding-left: 1rem;
}

.after\\:content-card-list-mobile::after{
  --tw-content: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  content: var(--tw-content);
}

.after\\:content-card-tile-mobile::after{
  --tw-content: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  content: var(--tw-content);
}

.after\\:content-sort::after{
  --tw-content: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  content: var(--tw-content);
}

.last\\:mb-2:last-child{
  margin-bottom: 0.5rem;
}

.hover\\:border-\\[\\#E9E8E8\\]:hover{
  --tw-border-opacity: 1;
  border-color: rgb(233 232 232 / var(--tw-border-opacity));
}

.hover\\:border-gray-50:hover{
  --tw-border-opacity: 1;
  border-color: rgb(194 194 194 / var(--tw-border-opacity));
}

.hover\\:border-primary-hover:hover{
  --tw-border-opacity: 1;
  border-color: rgb(26 50 192 / var(--tw-border-opacity));
}

.hover\\:bg-\\[var\\(--color-primary-bg\\)\\]:hover{
  background-color: var(--color-primary-bg);
}

.hover\\:bg-gray-30:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(237 237 237 / var(--tw-bg-opacity));
}

.hover\\:bg-gray-900:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity));
}

.hover\\:bg-primary:hover{
  background-color: var(--color-primary);
}

.hover\\:bg-primary-hover:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(26 50 192 / var(--tw-bg-opacity));
}

.hover\\:bg-stroke:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(233 232 232 / var(--tw-bg-opacity));
}

.hover\\:bg-white:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.hover\\:text-\\[var\\(--color-primary-bg\\)\\]:hover{
  color: var(--color-primary-bg);
}

.hover\\:text-white:hover{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.focus\\:ring-0:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-0:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.active\\:border-primary-pressed:active{
  --tw-border-opacity: 1;
  border-color: rgb(19 38 144 / var(--tw-border-opacity));
}

.active\\:bg-primary-pressed:active{
  --tw-bg-opacity: 1;
  background-color: rgb(19 38 144 / var(--tw-bg-opacity));
}

.active\\:text-primary-pressed:active{
  --tw-text-opacity: 1;
  color: rgb(19 38 144 / var(--tw-text-opacity));
}

.enabled\\:hover\\:text-gray-400:hover:enabled{
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}

.disabled\\:opacity-40:disabled{
  opacity: 0.4;
}

.disabled\\:hover\\:bg-transparent:hover:disabled{
  background-color: transparent;
}

.group:hover .group-hover\\:bg-primary-hover{
  --tw-bg-opacity: 1;
  background-color: rgb(26 50 192 / var(--tw-bg-opacity));
}

.group:hover .group-hover\\:fill-white{
  fill: #FFFFFF;
}

.group:active .group-active\\:bg-primary-pressed{
  --tw-bg-opacity: 1;
  background-color: rgb(19 38 144 / var(--tw-bg-opacity));
}

.group:disabled .group-disabled\\:text-gray-50{
  --tw-text-opacity: 1;
  color: rgb(194 194 194 / var(--tw-text-opacity));
}

.ui-open\\:rotate-0[data-headlessui-state~="open"]{
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.ui-open\\:bg-\\[var\\(--color-primary-bg\\)\\][data-headlessui-state~="open"]{
  background-color: var(--color-primary-bg);
}

:where([data-headlessui-state~="open"]) .ui-open\\:rotate-0{
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

:where([data-headlessui-state~="open"]) .ui-open\\:bg-\\[var\\(--color-primary-bg\\)\\]{
  background-color: var(--color-primary-bg);
}

.ui-checked\\:fill-black[data-headlessui-state~="checked"]{
  fill: #000000;
}

.ui-checked\\:text-black[data-headlessui-state~="checked"]{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}

:where([data-headlessui-state~="checked"]) .ui-checked\\:fill-black{
  fill: #000000;
}

:where([data-headlessui-state~="checked"]) .ui-checked\\:text-black{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}

.ui-selected\\:text-\\[var\\(--color-primary-bg\\)\\][data-headlessui-state~="selected"]{
  color: var(--color-primary-bg);
}

.ui-selected\\:after\\:content-select-checked[data-headlessui-state~="selected"]::after{
  --tw-content: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  content: var(--tw-content);
}

:where([data-headlessui-state~="selected"]) .ui-selected\\:text-\\[var\\(--color-primary-bg\\)\\]{
  color: var(--color-primary-bg);
}

:where([data-headlessui-state~="selected"]) .ui-selected\\:after\\:content-select-checked::after{
  --tw-content: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  content: var(--tw-content);
}

.ui-active\\:text-opacity-100[data-headlessui-state~="active"]{
  --tw-text-opacity: 1;
}

:where([data-headlessui-state~="active"]) .ui-active\\:text-opacity-100{
  --tw-text-opacity: 1;
}

@media (min-width: 768px){
  .md\\:right-1\\.5{
    right: 0.375rem;
  }
  .md\\:right-2{
    right: 0.5rem;
  }
  .md\\:mx-4{
    margin-left: 1rem;
    margin-right: 1rem;
  }
  .md\\:h-40{
    height: 10rem;
  }
  .md\\:w-40{
    width: 10rem;
  }
  .md\\:w-\\[123px\\]{
    width: 123px;
  }
  .md\\:max-w-2xl{
    max-width: 42rem;
  }
  .md\\:translate-x-0{
    --tw-translate-x: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
  .md\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .md\\:flex-col{
    flex-direction: column;
  }
  .md\\:gap-3{
    gap: 0.75rem;
  }
  .md\\:gap-5{
    gap: 1.25rem;
  }
  .md\\:gap-6{
    gap: 1.5rem;
  }
  .md\\:border{
    border-width: 1px;
  }
  .md\\:border-t-0{
    border-top-width: 0px;
  }
  .md\\:border-gray-30{
    --tw-border-opacity: 1;
    border-color: rgb(237 237 237 / var(--tw-border-opacity));
  }
  .md\\:border-transparent{
    border-color: transparent;
  }
  .md\\:px-\\[30px\\]{
    padding-left: 30px;
    padding-right: 30px;
  }
  .md\\:py-4{
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .md\\:py-6{
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  .md\\:pb-5{
    padding-bottom: 1.25rem;
  }
  .md\\:pl-0{
    padding-left: 0px;
  }
  .md\\:pl-4{
    padding-left: 1rem;
  }
  .md\\:text-3xl_t{
    font-size: 24px;
    line-height: 29px;
  }
  .md\\:last\\:mb-6:last-child{
    margin-bottom: 1.5rem;
  }
}

@media (min-width: 1200px){
  .lg\\:mx-auto{
    margin-left: auto;
    margin-right: auto;
  }
  .lg\\:w-\\[180px\\]{
    width: 180px;
  }
  .lg\\:w-\\[calc\\(100\\%-115px\\)\\]{
    width: calc(100% - 115px);
  }
  .lg\\:max-w-2xl{
    max-width: 42rem;
  }
  .lg\\:max-w-lg-container{
    max-width: 1440px;
  }
  .lg\\:max-w-lg-container-large{
    max-width: 1460px;
  }
  .lg\\:max-w-xl{
    max-width: 36rem;
  }
  .lg\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .lg\\:justify-start{
    justify-content: flex-start;
  }
  .lg\\:gap-\\[22px\\]{
    gap: 22px;
  }
  .lg\\:px-0{
    padding-left: 0px;
    padding-right: 0px;
  }
  .lg\\:text-3xl{
    font-size: 26px;
    line-height: 34px;
  }
}

@media (min-width: 1600px){
  .xl\\:max-w-3xl{
    max-width: 48rem;
  }
  .xl\\:max-w-xl-container{
    max-width: 1920px;
  }
  .xl\\:gap-\\[32px\\]{
    gap: 32px;
  }
  .xl\\:px-\\[50px\\]{
    padding-left: 50px;
    padding-right: 50px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/index.scss","webpack://./src/styles/styles.scss","webpack://./src/styles/_mixins.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;CAAA;AAAA;;;CAAA;AAAA;;;EAAA,sBAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,mBAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;AAAA;;EAAA,gBAAA;AAAA;AAAA;;;;;;;;CAAA;AAAA;;EAAA,gBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA,EAAA,MAAA;EAAA,WAAA,EAAA,MAAA;EAAA,+HAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,wCAAA,EAAA,MAAA;AAAA;AAAA;;;CAAA;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;AAAA;;;;CAAA;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,yCAAA;UAAA,iCAAA;AAAA;AAAA;;CAAA;AAAA;;;;;;EAAA,kBAAA;EAAA,oBAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,cAAA;EAAA,wBAAA;AAAA;AAAA;;CAAA;AAAA;;EAAA,mBAAA;AAAA;AAAA;;;;;CAAA;AAAA;;;;EAAA,+GAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,cAAA;AAAA;AAAA;;CAAA;AAAA;;EAAA,cAAA;EAAA,cAAA;EAAA,kBAAA;EAAA,wBAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,WAAA;AAAA;AAAA;;;;CAAA;AAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;EAAA,yBAAA,EAAA,MAAA;AAAA;AAAA;;;;CAAA;AAAA;;;;;EAAA,oBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA;EAAA,gCAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,uBAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,SAAA,EAAA,MAAA;EAAA,UAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;;EAAA,oBAAA;AAAA;AAAA;;;CAAA;AAAA;;;;EAAA,0BAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,aAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,wBAAA;AAAA;AAAA;;CAAA;AAAA;;EAAA,YAAA;AAAA;AAAA;;;CAAA;AAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,wBAAA;AAAA;AAAA;;;CAAA;AAAA;EAAA,0BAAA,EAAA,MAAA;EAAA,aAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;;CAAA;AAAA;;;;;;;;;;;;;EAAA,SAAA;AAAA;AAAA;EAAA,SAAA;EAAA,UAAA;AAAA;AAAA;EAAA,UAAA;AAAA;AAAA;;;EAAA,gBAAA;EAAA,SAAA;EAAA,UAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,UAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;;;CAAA;AAAA;;EAAA,UAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;;EAAA,eAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,eAAA;AAAA;AAAA;;;;CAAA;AAAA;;;;;;;;EAAA,cAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;;EAAA,eAAA;EAAA,YAAA;AAAA;AAAA,wEAAA;AAAA;EAAA,aAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA;AAAA;AACA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;AAAA;AACA;EAAA,kBAAA;EAAA,UAAA;EAAA,WAAA;EAAA,UAAA;EAAA,YAAA;EAAA,gBAAA;EAAA,sBAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,yBAAA;EAAA;AAAA;AAAA;EAAA,wBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,eAAA;EAAA,eAAA;EAAA;AAAA;AAAA;EAAA,eAAA;EAAA,eAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,yBAAA;UAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA,uBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,eAAA;EAAA;AAAA;AAAA;EAAA,eAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,eAAA;EAAA;AAAA;AAAA;EAAA,eAAA;EAAA;AAAA;AAAA;EAAA,eAAA;EAAA;AAAA;AAAA;EAAA,eAAA;EAAA;AAAA;AAAA;EAAA,cAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sCAAA;EAAA,oDAAA;EAAA;AAAA;AAAA;EAAA,gFAAA;EAAA,oGAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,2KAAA;EAAA,mKAAA;EAAA,4LAAA;EAAA,mEAAA;EAAA;AAAA;AAAA;EAAA,gKAAA;EAAA,wJAAA;EAAA,iLAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;ACAA,qFAAA;AACA;;EAEE,WAAA;EAEA,YAAA;ADGF;;ACAA;EACE,kBAAA;ADGF;;ACAA;EACE,8BAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,oBAAA;ADGF;AENI;EDJJ;IAUI,oBAAA;EDIF;AACF;AEhBI;EDCJ;IAcI,iBAAA;EDKF;AACF;;ACFA;EACE,UAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;ADKF;;ACFA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAmCE,UAAA;EACA,SAAA;EACA,aAAA;EACA,gBAAA;EAEA,sBAAA;EACA,2BAAA;ADIF;;ACDA;;;;;;EAME,cAAA;ADIF;;ACDA;;;EAGE,sBAAA;ADIF;;ACDA;EACE,mBAAA;EACA,YAAA;ADIF;;ACDA;EACE,aAAA;ADIF;;ACDA;;EAEE,eAAA;ADIF;;ACDA;;EAEE,SAAA;ADIF;;ACDA;EACE,yBAAA;EACA,iBAAA;ADIF;;ACDA;EACE,qBAAA;ADIF;;ACDA;EACE,qBAAA;ADIF;;ACDA;EACE,UAAA;EACA,WAAA;ADIF;;ACGA;EACE,qBAAA;EACA,mBAAA;ADAF;;ACOA;EACE;;;;;;;IAOE,6CAAA;IACA,wCAAA;IACA,yBAAA;IAIA,iBAAA;EDJF;AACF;ACOA,sFAAA;AAEA;;;;;;;;;;;EAWE,WAAA;EACA,gCAAA;EACA,cAAA;ADNF;;ACSA;EACE,oDAAA;ADNF;;ACSA;EACE,uDAAA;ADNF;;ACSA;EACE,sBAAA;EACA,2CAAA;ADNF;;ACSA;EACE,iDAAA;EACA,kDAAA;ADNF;;ACSA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,6BAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kDAAA;EACA,sCAAA;EACA,uCAAA;ADNF;;ACSA;EACE,8BAAA;ADNF;;ACSA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;ADNF;;ACSA;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,yDAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,kBAAA;EACA,0BAAA;ADNF;;ACSA;EACE,wBAAA;ADNF;;ACWE;EACE,yBAAA;ADRJ;ACUE;EACE,sBAAA;ADRJ;;ACWA;ECjOE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,UAAA;EDgOA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sCAAA;EACA,kBAAA;EACA,eAAA;EACA,6CAAA;EACA,wCAAA;EACA,yBAAA;EAIA,iBAAA;ADLF;AEzPI;ED4OJ;IAoBI,WAAA;IACA,YAAA;EDHF;AACF;AEpQI;EDiPJ;IAwBI,WAAA;IACA,YAAA;EDDF;AACF;AE/QI;EDsPJ;IA6BI,WAAA;IACA,YAAA;EDAF;AACF;ACEE;EACE,sCAAA;EAEA,yBAAA;ADDJ;ACIE;EACE,sBAAA;ADFJ;ACKE;EACE,cAAA;EACA,eAAA;EACA,mBAAA;ADHJ;ACME;EACE,oCAAA;ADJJ;AE/RI;EDiPJ;IAsDI,6BAAA;EDJF;ECME;IACE,qBAAA;EDJJ;ECOE;IACE,8CAAA;EDLJ;ECOI;IACE,sCAAA;IACA,wCAAA;EDLN;AACF;ACSI;EACE,0BAAA;ADPN;ACSM;EACE,0BAAA;EACA,4BAAA;ADPR;ACeE;EACE,kCAAA;ADbJ;;ACiBA;ECzTE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,UAAA;EDwTA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;EACA,qBAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,mCAAA;EACA,kBAAA;ADXF;ACaE;EACE,gCAAA;EACA,WAAA;EACA,sCAAA;ADXJ;AEnVI;EDyUJ;IAyBI,eAAA;IACA,gBAAA;IACA,6BAAA;EDXF;ECaE;IACE,qBAAA;EDXJ;ECcE;IACE,8CAAA;EDZJ;ECcI;IACE,iDAAA;IACA,mDAAA;EDZN;AACF;;ACkBE;EACE,kBAAA;ADfJ;ACiBE;EACE,kBAAA;ADfJ;ACiBE;EACE,SAAA;ADfJ;ACiBE;EACE,gBAAA;ADfJ;ACiBE;EACE,mBAAA;ADfJ;ACgBI;EACE,kBAAA;EACA,kBAAA;ADdN;ACgBM;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,sCAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;ADdR;ACiBM;EACE,mBAAA;ADfR;ACoBE;EACE,kBAAA;EACA,mBAAA;ADlBJ;ACoBI;EACE,wBAAA;ADlBN;ACmBM;EACE,mBAAA;ADjBR;ACsBE;EACE,WAAA;EACA,0BAAA;ADpBJ;AC8BA;EACE,UAAA;AD5BF;;AC8BA;EACE,UAAA;EACA,yBAAA;AD3BF;;AC6BA;EACE,UAAA;AD1BF;;AC4BA;EACE,UAAA;EACA,yBAAA;ADzBF;;AC4BA;EACE,UAAA;EACA,kBAAA;ADzBF;;ACoCA;EACE,8BAAA;EACA,gBAAA;ADjCF;;ACoCA;EACE,kCAAA;EACA,gBAAA;ADjCF;;ACoCA;EACE,aAAA;ADjCF;;ACoCA;EACE,aAAA;EACA,SAAA;ADjCF;;ACyCE;EACE,aAAA;ADtCJ;;AC+CE;EACE,aAAA;AD5CJ;;ACgDA;EACE,aAAA;EACA,sCAAA;EACA,QAAA;AD7CF;;ACoDA;EACE,aAAA;EACA,kBAAA;ADjDF;ACqDE;EACE,YAAA;EACA,kBAAA;ADnDJ;ACoDI;;EAEE,WAAA;EACA,YAAA;ADlDN;ACoDI;EACE,WAAA;ADlDN;;AC0DE;EACE,UAAA;ADvDJ;;AC+DA;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,sCAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;AD5DF;AC6DE;EACE,qBAAA;EACA,yBAAA;AD3DJ;AC8DI;EACE,YAAA;EACA,UAAA;AD5DN;;ACiEA;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;EAEA,aAAA;EACA,UAAA;EACA,UAAA;EACA,0BAAA;EACA,oBAAA;AD/DF;ACgEE;EACE,WAAA;AD9DJ;AE/fI;EDkjBJ;IAkBI,cAAA;EDjEF;AACF;AEzgBI;EDujBJ;IAsBI,iBAAA;EDhEF;AACF;;ACmEA;EACE,sCAAA;EACA,sBAAA;ADhEF;ACiEE;EACE,WAAA;EACA,YAAA;AD/DJ;;ACmEA;EACE,aAAA;EACA,SAAA;ADhEF;ACiEE;EACE,WAAA;EACA,mBAAA;AD/DJ;;AC0EE;EACE,cAAA;ADvEJ;AC0EE;EACE,aAAA;ADxEJ;AC8EE;EACE,aAAA;AD5EJ;AC+EE;EACE,aAAA;AD7EJ;ACgFE;EACE,mBAAA;AD9EJ;AC+EI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AD7EN;ACkFE;EACE,aAAA;ADhFJ;ACuFE;EACE,eAAA;EACA,eAAA;EAEA,gBAAA;EACA,YAAA;EACA,oBAAA;ADtFJ;ACyFE;EACE,iBAAA;EACA,kBAAA;ADvFJ;AC0FE;EACE,aAAA;EACA,sBAAA;ADxFJ;AC2FE;EACE,aAAA;ADzFJ;;AC6FA;EACE,aAAA;EACA,YAAA;AD1FF;;AC6FA;EACE,kBAAA;AD1FF;;AC6FA;EACE,oCAAA;AD1FF;;AC6FA;EACE,aAAA;AD1FF;;AC+GA;EACE,kBAAA;AD5GF;AC8GE;EACE,qBAAA;AD5GJ;;ACgHA;EACE,kBAAA;EACA,OAAA;EACA,MAAA;AD7GF;;ACiHA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EAEA,UAAA;EACA,WAAA;AD/GF;;AC4HA;EACE,eAAA;EACA,UAAA;EACA,2BAAA;ADzHF;AC2HE;EAEE,YAAA;EACA,YAAA;AD1HJ;;ACiJA;EACE,6BAAA;AD9IF;;ACsKA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;ADnKF;;ACkOA;EACE,YAAA;EACA,aAAA;EACA,qBAAA;EACA,sBAAA;AD/NF;ACgOE;EACE,2BAAA;AD9NJ;ACgOE;EACE,aAAA;EACA,qCAAA;EACA,QAAA;AD9NJ;AC+NI;EACE,iBAAA;AD7NN;ACqOA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,WAAA;ADnOF;ACoOE;EACE,2BAAA;ADlOJ;ACqOE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ADnOJ;;ACuOA;EACE,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,gCAAA;EACA,YAAA;EACA,kBAAA;EAEA,eAAA;EAKA,eAAA;EACA,YAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;ADxOF;AC2OE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,cAAA;ADzOJ;ACwPE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;ADtPJ;AC6PE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,cAAA;AD3PJ;AC8PE;EACE,cAAA;EACA,iDAAA;EACA,oBAAA;AD5PJ;AC+PE;EAEE,cAAA;EACA,eAAA;AD9PJ;;ACuQA;EACE,WAAA;EACA,6BAAA;EACA,oBAAA;EACA,mBAAA;EACA,gCAAA;ADpQF;;ACyQA;EACE,6BAAA;EAEA,iBAAA;EAGA,8BAAA;ADzQF;;AC4QA;EACE,gCAAA;ADzQF;;AC4QA;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;ADzQF;;AC4QA;EACE,6BAAA;ADzQF;;AC4QA;EACE,6BAAA;ADzQF;;AC4QA;EACE,yBAAA;EACA,wBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;ADzQF;;AC8QE;EACE,yBAAA;AD3QJ;;AC+QA;EACE,oCAAA;EACA,qBAAA;AD5QF;;AC+QA;EACE,uBAAA;AD5QF;;ACgRE;EACE,iDAAA;EACA,6CAAA;AD7QJ;;ACiRA;EACE,iDAAA;EACA,6CAAA;AD9QF;;ACkRE;EACE,gCAAA;AD/QJ;;ACmRA;EACE,iDAAA;ADhRF;;ACwRA;EACE,aAAA;EACA,8BAAA;EACA,eAAA;EACA,gCAAA;EACA,oBAAA;ADrRF;ACsRE;EACE,cAAA;ADpRJ;ACsRE;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;ADpRJ;;ACwRA;EAEE,aAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;ADtRF;ACuRE;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,oEAAA;ADrRJ;ACwRE;EACE,WAAA;ADtRJ;;AC4RE;EAEE,eAAA;AD1RJ;AC+RE;EACE,YAAA;AD7RJ;ACgSE;EACE,SAAA;EACA,cAAA;AD9RJ;;ACkSA;EAEE,yBAAA;EACA,kBAAA;ADhSF;;ACsSA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;EACA,2BAAA;EACA,eAAA;EACA,cAAA;ADnSF;;ACsSA;EAIE,YAAA;ADtSF;;AC0SE;EAGE,WAAA;EACA,WAAA;EACA,gBAAA;ADzSJ;AC2SE;EACE,mBAAA;ADzSJ;AC0SI;EACE,gCAAA;ADxSN;;ACiTA;EAEE,iDAAA;AD/SF;;ACsTA;EACE,kBAAA;ADnTF;;ACsTA;EACE,2BAAA;ADnTF;;ACsTA;EACE,aAAA;EACA,SAAA;ADnTF;;ACiUA;;EAEE,8BAAA;AD9TF;;ACiUA;;;;EAIE,kCAAA;AD9TF;;ACiUA;EACE,kCAAA;AD9TF;;ACiUA;;EAEE,kCAAA;AD9TF;;ACiUA;EACE,YAAA;AD9TF;;ACiUA;EACE,sBAAA;EACA,WAAA;EACA,eAAA;EAEA,aAAA;EACA,qCAAA;AD/TF;;ACkUA;EACE,gBAAA;AD/TF;ACgUE;EACE,cAAA;AD9TJ;ACiUE;EACE,WAAA;EACA,gBAAA;EACA,8BAAA,EAAA,yBAAA;EACA,gBAAA,EAAA,oCAAA;EACA,kCAAA,EAAA,yBAAA;AD/TJ;ACiUI;EACE,0BAAA;AD/TN;;ACoUA;EACE,sCAAA;EACA,6CAAA;ADjUF;;ACoUA;EACE,mCAAA;EACA,yCAAA;ADjUF;ACkUE;EACE,kCAAA;EACA,wCAAA;ADhUJ;;ACoUA;EACE,mCAAA;EACA,yCAAA;ADjUF;ACkUE;EACE,kCAAA;EACA,wCAAA;ADhUJ;;ACoUA;EACE,mCAAA;EACA,yCAAA;ADjUF;ACkUE;EACE,kCAAA;EACA,wCAAA;ADhUJ;;ACoUA;EACE,mCAAA;EACA,yCAAA;ADjUF;ACkUE;EACE,kCAAA;EACA,wCAAA;ADhUJ;;ACoUA;EACE,2CAAA;EACA,iDAAA;ADjUF;ACkUE;EACE,0CAAA;EACA,iDAAA;ADhUJ;;ACoUA;EACE,wCAAA;EACA,8CAAA;ADjUF;ACkUE;EACE,uCAAA;EACA,6CAAA;ADhUJ;;ACoUA;EACE,eAAA;ADjUF;;ACoUA;EACE,0BAAA;ADjUF;;AA5/BA;EAAA,eA4/BA;EA5/BA;AA4/BA;;AA5/BA;EAAA,oBA4/BA;EA5/BA;AA4/BA;;AA5/BA;EAAA,qDA4/BA;EA5/BA;AA4/BA;;AA5/BA;EAAA,0BA4/BA;EA5/BA;AA4/BA;;AA5/BA;EAAA,qDA4/BA;EA5/BA;AA4/BA;;AA5/BA;EAAA,qDA4/BA;EA5/BA;AA4/BA;;AA5/BA;EAAA,qDA4/BA;EA5/BA;AA4/BA;;AA5/BA;EAAA;AA4/BA;;AA5/BA;EAAA,sBA4/BA;EA5/BA;AA4/BA;;AA5/BA;EAAA,sBA4/BA;EA5/BA;AA4/BA;;AA5/BA;EAAA,sBA4/BA;EA5/BA;AA4/BA;;AA5/BA;EAAA;AA4/BA;;AA5/BA;EAAA,kBA4/BA;EA5/BA;AA4/BA;;AA5/BA;EAAA,kBA4/BA;EA5/BA;AA4/BA;;AA5/BA;EAAA;AA4/BA;;AA5/BA;EAAA,kBA4/BA;EA5/BA;AA4/BA;;AA5/BA;EAAA,kBA4/BA;EA5/BA;AA4/BA;;AA5/BA;EAAA,kBA4/BA;EA5/BA;AA4/BA;;AA5/BA;EAAA;AA4/BA;;AA5/BA;EAAA,oBA4/BA;EA5/BA;AA4/BA;;AA5/BA;EAAA,2GA4/BA;EA5/BA,yGA4/BA;EA5/BA;AA4/BA;;AA5/BA;EAAA,2GA4/BA;EA5/BA,yGA4/BA;EA5/BA;AA4/BA;;AA5/BA;EAAA,sBA4/BA;EA5/BA;AA4/BA;;AA5/BA;EAAA,kBA4/BA;EA5/BA;AA4/BA;;AA5/BA;EAAA,oBA4/BA;EA5/BA;AA4/BA;;AA5/BA;EAAA,oBA4/BA;EA5/BA;AA4/BA;;AA5/BA;EAAA;AA4/BA;;AA5/BA;EAAA;AA4/BA;;AA5/BA;EAAA,kBA4/BA;EA5/BA;AA4/BA;;AA5/BA;EAAA;AA4/BA;;AA5/BA;EAAA,kBA4/BA;EA5/BA;AA4/BA;;AA5/BA;EAAA,oBA4/BA;EA5/BA;AA4/BA;;AA5/BA;EAAA,iBA4/BA;EA5/BA;AA4/BA;;AA5/BA;EAAA;AA4/BA;;AA5/BA;EAAA,iBA4/BA;EA5/BA;AA4/BA;;AA5/BA;EAAA;AA4/BA;;AA5/BA;EAAA;AA4/BA;;AA5/BA;EAAA,oBA4/BA;EA5/BA;AA4/BA;;AA5/BA;EAAA;AA4/BA;;AA5/BA;EAAA,oBA4/BA;EA5/BA;AA4/BA;;AA5/BA;EAAA;AA4/BA;;AA5/BA;EAAA,qDA4/BA;EA5/BA;AA4/BA;;AA5/BA;EAAA;AA4/BA;;AA5/BA;EAAA,qDA4/BA;EA5/BA;AA4/BA;;AA5/BA;EAAA;AA4/BA;;AA5/BA;EAAA;AA4/BA;;AA5/BA;EAAA;IAAA;EA4/BA;EA5/BA;IAAA;EA4/BA;EA5/BA;IAAA,iBA4/BA;IA5/BA;EA4/BA;EA5/BA;IAAA;EA4/BA;EA5/BA;IAAA;EA4/BA;EA5/BA;IAAA;EA4/BA;EA5/BA;IAAA;EA4/BA;EA5/BA;IAAA,qBA4/BA;IA5/BA;EA4/BA;EA5/BA;IAAA;EA4/BA;EA5/BA;IAAA;EA4/BA;EA5/BA;IAAA;EA4/BA;EA5/BA;IAAA;EA4/BA;EA5/BA;IAAA;EA4/BA;EA5/BA;IAAA;EA4/BA;EA5/BA;IAAA;EA4/BA;EA5/BA;IAAA,sBA4/BA;IA5/BA;EA4/BA;EA5/BA;IAAA;EA4/BA;EA5/BA;IAAA,kBA4/BA;IA5/BA;EA4/BA;EA5/BA;IAAA,iBA4/BA;IA5/BA;EA4/BA;EA5/BA;IAAA,mBA4/BA;IA5/BA;EA4/BA;EA5/BA;IAAA;EA4/BA;EA5/BA;IAAA;EA4/BA;EA5/BA;IAAA;EA4/BA;EA5/BA;IAAA,eA4/BA;IA5/BA;EA4/BA;EA5/BA;IAAA;EA4/BA;AAAA;;AA5/BA;EAAA;IAAA,iBA4/BA;IA5/BA;EA4/BA;EA5/BA;IAAA;EA4/BA;EA5/BA;IAAA;EA4/BA;EA5/BA;IAAA;EA4/BA;EA5/BA;IAAA;EA4/BA;EA5/BA;IAAA;EA4/BA;EA5/BA;IAAA;EA4/BA;EA5/BA;IAAA;EA4/BA;EA5/BA;IAAA;EA4/BA;EA5/BA;IAAA;EA4/BA;EA5/BA;IAAA,iBA4/BA;IA5/BA;EA4/BA;EA5/BA;IAAA,eA4/BA;IA5/BA;EA4/BA;AAAA;;AA5/BA;EAAA;IAAA;EA4/BA;EA5/BA;IAAA;EA4/BA;EA5/BA;IAAA;EA4/BA;EA5/BA;IAAA,kBA4/BA;IA5/BA;EA4/BA;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@400;500;700&display=swap\");\n@import \"./styles.scss\";\n","@import \"./mixins\";\n\n/*------------------------------RESET DEFAULT STYLES--------------------------------*/\nhtml,\nbody {\n  width: 100%;\n  // scroll-behavior: smooth;\n  height: 100%;\n}\n\nbody {\n  overflow-x: hidden;\n}\n\n#root {\n  font-family: theme(\"fontFamily.primary\");\n  color: theme(\"colors.black\");\n  background: theme(\"colors.white\");\n  display: flex;\n  flex-direction: column;\n  min-height: 100%;\n  padding-bottom: 50px;\n\n  @include respond(tab) {\n    padding-bottom: 64px;\n  }\n\n  @include respond(laptop) {\n    padding-bottom: 0;\n  }\n}\n\nbody {\n  padding: 0;\n  margin: 0;\n  line-height: 1.5;\n  background: #fff;\n}\n\ndiv,\np,\na,\nspan,\nem,\nstrong,\nimg,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nul,\nol,\nli,\ndl,\ndt,\ndd,\ntable,\ntd,\ntr,\nform,\nfieldset,\nlabel,\nselect,\ninput,\ntextarea,\nheader,\nnav,\nsection,\narticle,\naside,\nfooter,\nblockquote {\n  padding: 0;\n  margin: 0;\n  outline: none;\n  list-style: none;\n\n  box-sizing: border-box;\n  -moz-box-sizing: border-box;\n}\n\nheader,\nnav,\nsection,\narticle,\naside,\nfooter {\n  display: block;\n}\n\nselect,\ninput,\ntextarea {\n  vertical-align: middle;\n}\n\ntextarea {\n  vertical-align: top;\n  resize: none;\n}\n\n:focus {\n  outline: none;\n}\n\ninput[type=\"submit\"],\nbutton {\n  cursor: pointer;\n}\n\nimg,\nfieldset {\n  border: 0;\n}\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\na {\n  text-decoration: none;\n}\n\na:hover {\n  text-decoration: none;\n}\n\n::-webkit-scrollbar {\n  width: 7px;\n  height: 3px;\n}\n\n// ::-webkit-scrollbar-track {\n//   background: rgb(236, 236, 236);\n// }\n\n::-webkit-scrollbar-thumb {\n  border-radius: 1000px;\n  background: #b8b7b7;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  // background: var(--color-primary);\n}\n\n@media only screen and (max-width: 1100px) {\n  button,\n  textarea,\n  input,\n  select,\n  a,\n  div,\n  span {\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n    -webkit-tap-highlight-color: transparent;\n    -webkit-user-select: none;\n    -khtml-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n  }\n}\n\n/*-----------------------------RESET DEFAULT STYLES END------------------------------*/\n\nh1::selection,\nh2::selection,\nh3::selection,\np::selection,\nli::selection,\na::selection,\nstrong::selection,\nspan::selection,\nblockquote::selection,\nimg::selection,\naddress::selection {\n  color: #fff;\n  background: theme(\"colors.primary\");\n  /* Цвет фона */\n}\n\n.dialog-filter {\n  filter: drop-shadow(0px 2px 6px rgba(0, 0, 0, 0.04));\n}\n\n.apartment-card-filter {\n  filter: drop-shadow(0px 4px 20px rgba(45, 46, 48, 0.1));\n}\n\n.bar {\n  height: 4px !important;\n  background: theme(\"colors.primary\") !important;\n}\n\n.spinner-icon {\n  border-top-color: theme(\"colors.primary\") !important;\n  border-left-color: theme(\"colors.primary\") !important;\n}\n\n.nspinner {\n  width: 24px;\n  height: 24px;\n  box-sizing: border-box;\n  border: solid 2px transparent;\n  border-top-color: #29d;\n  border-left-color: #29d;\n  border-radius: 50%;\n  animation: nprogress-spinner 400ms linear infinite;\n  border-top-color: theme(\"colors.primary\");\n  border-left-color: theme(\"colors.primary\");\n}\n\n.chakra-alert {\n  background: #000000 !important;\n}\n\n.close-btn {\n  width: 55px;\n  height: 55px;\n  border-radius: 50%;\n  background-color: var(--color-primary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.close-btn::after {\n  content: \"\";\n  width: 12px;\n  height: 12px;\n  background-image: url(\"../assets/close.svg\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  position: absolute;\n  transition: transform 0.3s;\n}\n\n.close-btn:hover::after {\n  transform: rotate(90deg);\n}\n//\n\n.flat-page-3d {\n  .flat-card-right-sidebar {\n    border-color: transparent; // линия\n  }\n  .button-3d-home-control {\n    background-color: #000;\n  }\n}\n.rounded-btn {\n  @include reset-btn;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f7fafd;\n  border: 1px solid var(--color-primary);\n  position: relative;\n  cursor: pointer;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  -webkit-tap-highlight-color: transparent;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  @include respond(tab) {\n    width: 55px;\n    height: 55px;\n  }\n  @include respond(laptop) {\n    width: 50px;\n    height: 50px;\n  }\n\n  @include respond(desktop) {\n    width: 55px;\n    height: 55px;\n  }\n\n  &.primary-color {\n    background-color: var(--color-primary);\n\n    border: 1px solid #e3ecf5;\n  }\n\n  &.white-color {\n    background-color: #fff;\n  }\n\n  img {\n    display: block;\n    max-width: 100%;\n    object-fit: contain;\n  }\n\n  svg path {\n    transition: fill 0.25s, stroke 0.25s;\n  }\n\n  @include respond(laptop) {\n    transition: border-color 0.3s;\n\n    &:hover {\n      border-color: #d0dce8;\n    }\n\n    &.primary-color {\n      transition: background 0.3s, border-color 0.3s;\n\n      &:hover {\n        background: var(--color-primary-hover);\n        border-color: var(--color-primary-hover);\n      }\n    }\n  }\n  &.active {\n    > svg {\n      fill: var(--color-primary);\n\n      path {\n        fill: var(--color-primary);\n        stroke: var(--color-primary);\n      }\n      // circle {\n      //   fill: red;\n      // }\n    }\n  }\n\n  &.no-border {\n    border: 1px solid white !important;\n  }\n}\n\n.main-btn {\n  @include reset-btn;\n  border: 1px solid #e9e8e8;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  justify-content: center;\n  gap: 10px;\n  border-radius: 1000px;\n  padding: 18px;\n  min-width: 150px;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 100%;\n  color: #000;\n  background: var(--color-primary-bg);\n  text-align: center;\n\n  &.primary-color {\n    background: var(--color-primary);\n    color: #fff;\n    border: 1px solid var(--color-primary);\n  }\n\n  @include respond(laptop) {\n    padding: 20.5px;\n    min-width: 175px;\n    transition: border-color 0.3s;\n\n    &:hover {\n      border-color: #c2c2c2;\n    }\n\n    &.primary-color {\n      transition: background 0.3s, border-color 0.3s;\n\n      &:hover {\n        background: var(--color-primary-hover) !important;\n        border-color: var(--color-primary-hover) !important;\n      }\n    }\n  }\n}\n\n.text {\n  p {\n    margin: 0 0 20px 0;\n  }\n  p:first-of-type {\n    margin: 0 0 20px 0;\n  }\n  p:last-child {\n    margin: 0;\n  }\n  strong {\n    font-weight: 500;\n  }\n  ul {\n    margin-bottom: 50px;\n    li {\n      position: relative;\n      padding-left: 35px;\n\n      &::before {\n        content: \"\";\n        width: 8px;\n        height: 8px;\n        background-color: var(--color-primary);\n        position: absolute;\n        top: 10px;\n        left: 0;\n      }\n\n      &:not(:last-child) {\n        margin-bottom: 20px;\n      }\n    }\n  }\n\n  ol {\n    padding-left: 32px;\n    margin-bottom: 50px;\n\n    li {\n      list-style-type: decimal;\n      &:not(:last-child) {\n        margin-bottom: 16px;\n      }\n    }\n  }\n\n  a {\n    color: #000;\n    text-decoration: underline;\n  }\n\n  @include respond(tab) {\n  }\n\n  @include respond(laptop) {\n  }\n}\n\n.fade-enter {\n  opacity: 0;\n}\n.fade-enter-active {\n  opacity: 1;\n  transition: opacity 500ms;\n}\n.fade-exit {\n  opacity: 1;\n}\n.fade-exit-active {\n  opacity: 0;\n  transition: opacity 500ms;\n}\n\n.input-position {\n  width: 50%;\n  position: relative;\n}\n\n.chakra-portal > div {\n  // pointer-events: all;\n}\n\n// .magnifying-glass {\n//   pointer-events: all !important;\n// }\n\n.rc-slider-track {\n  background: #1edc94 !important;\n  transition: 0.5s;\n}\n\n.rc-slider-handle {\n  background-color: white !important;\n  transition: 0.5s;\n}\n\n.ant-checkbox-wrapper {\n  display: flex;\n}\n\n.page-filter {\n  display: flex;\n  gap: 50px;\n}\n\n.visual {\n  .tag-card {\n    // left: auto;\n    // right: 20px !important;\n  }\n  .control-button-card {\n    display: none;\n  }\n}\n\n// .tag-card {\n//   height: 30px;\n// }\n\n.flat-page {\n  .filter-control-panel-3d {\n    display: none;\n  }\n}\n\n.additional_filter {\n  display: grid;\n  grid-template-columns: repeat(2, auto);\n  gap: 8px;\n}\n\n// .dynamic-content-flat-page {\n//   padding: 30px;\n// }\n\n.house-3d-preview {\n  display: flex;\n  position: relative;\n  // margin-top: 30px;\n  // padding-bottom: 80px;\n\n  .control-3d {\n    bottom: 10px;\n    position: absolute;\n    button,\n    > div {\n      width: 25px;\n      height: 25px;\n    }\n    svg {\n      width: 10px;\n    }\n    // bottom: 0px;\n    // bottom: 1px;\n  }\n}\n\n.modal-3d-antd {\n  .ant-modal-content {\n    padding: 0;\n  }\n\n  // .ant-modal-close {\n  //   display: none;\n  // }\n}\n\n.house-3d-preview-button {\n  position: absolute;\n  right: 20px;\n  cursor: pointer;\n  bottom: 10px;\n  background-color: var(--color-primary);\n  border-radius: 50%;\n  padding: 10px;\n  transition: 0.3s;\n  &:hover {\n    transform: scale(1.1);\n    background-color: #000000;\n  }\n  svg {\n    path {\n      stroke: #fff;\n      fill: #fff;\n    }\n  }\n}\n\n.page-filter__left {\n  min-width: 410px;\n  max-width: 410px;\n  position: sticky;\n  // padding-top: 16px;\n  display: none;\n  top: 100px;\n  left: 30px;\n  height: calc(100vh - 90px);\n  padding-bottom: 50px;\n  > div {\n    width: 100%;\n  }\n\n  @include respond(tab) {\n  }\n\n  @include respond(laptop) {\n    display: block;\n  }\n\n  @include respond(desktop) {\n    padding-top: 20px;\n  }\n}\n\n.slider-filter {\n  color: var(--color-primary) !important;\n  height: 1px !important;\n  .MuiSlider-thumb {\n    width: 16px;\n    height: 16px;\n  }\n}\n\n.wrapper_slider {\n  display: flex;\n  gap: 20px;\n  > div {\n    width: 95px;\n    height: fit-content;\n    // height: 28px;\n  }\n  // flex-wrap: wrap;\n  // margin-bottom: 50px;\n\n  // padding: 10px;\n  // border: 1px solid gainsboro;\n}\n\n.modal-filter {\n  .page-filter {\n    display: block;\n    // display: flex;\n  }\n  .go_to_visual {\n    display: none;\n  }\n  // .filter-page__reset-button {\n  //   display: none;\n  // }\n\n  .filter-page-dev-field {\n    display: flex;\n  }\n\n  .filter-page__select-sort {\n    display: none;\n  }\n\n  .filter-page__flat-card {\n    flex-direction: row;\n    img {\n      width: 91px;\n      height: 91px;\n      object-fit: cover;\n      // margin-top: 20px;\n    }\n  }\n\n  .filter-page__switch-mode {\n    display: none;\n  }\n\n  // .filter-page__loadmore-button {\n  //   display: none;\n  // }\n\n  .page-filter__left {\n    max-width: auto;\n    min-width: auto;\n    // top: 0;\n    position: static;\n    height: auto;\n    padding-bottom: 20px;\n  }\n\n  .MuiSlider-root {\n    margin-left: 20px;\n    margin-right: 20px;\n  }\n\n  .filter-apartaments-list {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .wrapperAdv {\n    display: none;\n  }\n}\n\n.page-filter-mobile {\n  padding: 20px;\n  height: 100%;\n}\n\n.rotate-image-container {\n  position: relative;\n}\n\n.rotating-image {\n  transition: opacity 0.5s ease-in-out;\n}\n\n.image-container {\n  display: flex;\n  // transition: 2s;\n}\n\n// #image {\n//   max-width: 100%;\n//   animation: fade 0.2s linear;\n//   animation-delay: 0.2s;\n// }\n// @keyframes fade {\n//   0% {\n//     opacity: 1;\n//   }\n//   50% {\n//     opacity: 0;\n//   }\n//   100% {\n//     opacity: 1;\n//   }\n// }\n\n.image-slider {\n  position: relative;\n\n  button {\n    background-color: red;\n  }\n}\n\n.image-slider-svg {\n  position: absolute;\n  left: 0;\n  top: 0;\n  // shape-rendering: optimizeSpeed;\n}\n\n.slider-3d-control {\n  position: absolute;\n  top: 0;\n  left: 0;\n\n  z-index: 1;\n  width: 100%;\n}\n\n// .slide-3d {\n//   // width: 100vw;\n//   // height: 100vh;\n//   // object-fit: cover;\n//   // opacity: 0.5;\n// }\n\n// polygon {\n// }\n\ng {\n  cursor: pointer;\n  opacity: 0;\n  pointer-events: visibleFill;\n\n  &:hover,\n  &.active {\n    stroke: #fff;\n    opacity: 0.7;\n  }\n}\n\n// g {\n//   cursor: pointer;\n//   opacity: 0;\n//   pointer-events: visibleFill; /* Исправленное значение */\n\n//   &:hover,\n//   &.active {\n//     stroke: #fff;\n//     opacity: 0.7;\n//   }\n\n//   @media (hover: none) {\n//     &:hover {\n//       stroke: none; /* Убираем hover-эффект на устройствах с сенсорным вводом */\n//       opacity: 0; /* Или другое значение, если нужно */\n//     }\n//   }\n// }\n\n.ant-popover-inner {\n  border-radius: 4px !important;\n}\n\n// .polygon-container {\n//   cursor: pointer;\n//   &:hover {\n//     & > polygon {\n//       opacity: 1;\n//       stroke: var(--color_stroke_hover);\n//       fill: var(--bg_color_hover);\n//     }\n\n//     .circle {\n//       opacity: 1;\n//     }\n//   }\n\n//   .hovered {\n//     opacity: 1;\n//     stroke: var(--color_stroke_hover);\n//     fill: var(--bg_color_hover);\n//   }\n// }\n\n.image-slider__image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  // transition: opacity 5s ease-in-out !important; /* Плавная смена с использованием CSS-транзиции */\n}\n\n// #test {\n//   max-width: 800px;\n//   margin: 0 auto;\n//   overflow: hidden;\n// }\n// #test img {\n//   max-width: 100%;\n//   animation: none 2s linear forwards;\n// }\n\n// .current-image {\n//   width: 800px;\n//   height: 450px;\n// }\n\n// @keyframes img-in {\n//   0% {\n//     filter: grayscale(100%);\n//     opacity: 0;\n//     transform: scale(1.05);\n//   }\n//   50% {\n//     filter: grayscale(100%);\n//     opacity: 1;\n//     transform: scale(1);\n//   }\n//   100% {\n//     filter: grayscale(0);\n//   }\n// }\n// @keyframes img-out {\n//   0% {\n//     filter: grayscale(0);\n//     opacity: 1;\n//     transform: scale(1);\n//   }\n//   30% {\n//     filter: grayscale(100%);\n//   }\n//   100% {\n//     filter: grayscale(100%);\n//     opacity: 0;\n//     transform: scale(1.05);\n//   }\n// }\n\n// .hidden {\n//   // opacity: 0;\n//   // transition: 2s;\n//   // border: 1px solid red;\n// }\n\n// .visible {\n//   // padding: 20px;\n//   // border: 1px solid red;\n//   // transition: 2s;\n//   // opacity: 0.5;\n// }\n\n.popup-info-flat {\n  width: 300px;\n  display: flex;\n  justify-items: center;\n  flex-direction: column;\n  > div {\n    flex-direction: row-reverse;\n  }\n  ul {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 5px;\n    li p:last-child {\n      font-weight: bold;\n    }\n  }\n  img {\n    // filter: grayscale(100%) brightness(70%) contrast(301%);\n  }\n}\n\n.button-back-flat {\n  display: flex;\n  align-items: center;\n  font-size: 12px;\n  z-index: 10000;\n  position: absolute;\n  transition: 0.3s;\n  top: -9px;\n  right: 21px;\n  &:hover {\n    color: var(--color-primary);\n  }\n  // left: 0;\n  button {\n    width: 35px;\n    height: 35px;\n    margin-right: 15px;\n  }\n}\n\n.popup-info-master-plan {\n  display: none;\n  padding: 15px 25px;\n  border-radius: 5px;\n  background: var(--color-primary);\n  color: white;\n  position: absolute;\n  z-index: 13;\n  font-size: 14px;\n  // width: 80vw;\n  // left: 50% !important;\n  // top: 50% !important;\n  // transform: translate(-50%, -50%);\n  position: fixed;\n  width: 200px;\n  top: 50%;\n  z-index: 1;\n  left: 50%;\n  // transform: translate(0) !important;\n\n  &__block {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 6px 0;\n  }\n\n  // @include respond(tab) {\n  // position: fixed;\n  // width: 200px;\n  // top: 50%;\n  // left: 50%;\n  // transform: translate(0);\n  // }\n\n  // @include respond(laptop) {\n  //   padding-bottom: 0;\n  // }\n\n  &__number {\n    font-size: 35px;\n    line-height: 1;\n    font-weight: 500;\n  }\n\n  &__stage {\n    // font-size: 12px;\n  }\n\n  & > div > div {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 6px 0;\n  }\n\n  &__floor {\n    display: block;\n    border-bottom: 1px solid rgba(183, 216, 250, 0.2);\n    padding-bottom: 12px;\n  }\n\n  &__deadline {\n    // padding-top: 12px;\n    color: #b7d8fa;\n    font-size: 12px;\n  }\n\n  // <h2 class\"popup-info-master-plan__number\">17</h2>\n  // <p class\"popup-info-master-plan__floor\">Поверхів</p>\n  // <p class\"popup-info-master-plan__deadline\">Термін здачі</p>\n  // <p class\"popup-info-master-plan__stage\">1 Черга</p>\n}\n\n.popup-info-master-plan__mobile {\n  width: 80vw;\n  position: absolute !important;\n  left: 50% !important;\n  top: 50% !important;\n  transform: translate(-50%, -50%);\n}\n\n// filter\n\n.ant-input-number-input {\n  text-align: center !important;\n\n  padding: 8px 10px;\n  // border-radius: 3px !important;\n  // border: 1px solid#e3ecf5 !important;\n  background: #f7fafd !important;\n}\n\n.ant-input-number-input-wrap {\n  border-color: #e3ecf5 !important;\n}\n\n.filter-control-label {\n  color: #757575;\n  margin-top: 20px;\n  margin-bottom: 10px;\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 100%; /* 13px */\n}\n\n.ant-checkbox {\n  border-radius: 3px !important;\n}\n\n.ant-checkbox-inner {\n  border-color: #000 !important;\n}\n\n.ant-checkbox + span {\n  padding-inline-start: 7px;\n  padding-inline-end: 13px;\n  font-family: Inter;\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 100%; /* 13px */\n  // text-transform: lowercase;\n}\n\n.filter-control-rooms {\n  .ant-checkbox + span {\n    text-transform: lowercase;\n  }\n}\n\n.MuiSlider-rail {\n  background-color: #e3ecf5 !important;\n  opacity: 1 !important;\n}\n\n.MuiSlider-track {\n  border: none !important;\n}\n\n.ant-checkbox-checked {\n  .ant-checkbox-inner {\n    background-color: var(--color-primary) !important;\n    border-color: var(--color-primary) !important;\n  }\n}\n\n.ant-radio-checked .ant-radio-inner {\n  background-color: var(--color-primary) !important;\n  border-color: var(--color-primary) !important;\n}\n\n.ant-checkbox-disabled {\n  .ant-checkbox-inner {\n    border-color: #e2e8f0 !important;\n  }\n}\n\n.MuiSlider-valueLabel {\n  background-color: var(--color-primary) !important;\n  // background-color: #000 !important;\n}\n\n.ant-input-number {\n  // width: 56px !important;\n}\n\n.filter-status {\n  display: flex;\n  justify-content: space-between;\n  font-size: 13px;\n  border-bottom: 1px solid #e3ecf5;\n  padding-bottom: 10px;\n  p {\n    color: #757575;\n  }\n  b {\n    color: #000;\n    font-weight: 500;\n    margin-left: 5px;\n    text-transform: lowercase;\n  }\n}\n\n.filter-page__reset-button {\n  // background-image: url(\"icons/arrow-back.svg\");\n  display: flex;\n  color: #757575;\n  transition: 0.25s;\n  align-items: center;\n  &::before {\n    content: \"\";\n    display: block;\n    width: 25px;\n    height: 25px;\n    margin-right: 5px;\n    border-radius: 50%;\n    border: 1px solid #e3ecf5;\n    background: url(\"../assets/arrow-back.svg\") no-repeat center;\n    // padding-left: 20px;\n  }\n  &:hover {\n    color: #000;\n  }\n}\n\n.filter-wrapper-price {\n  // display: flex;\n  .wrapper_slider {\n    // display: flex;\n    flex-wrap: wrap;\n    // flex-direction: column;\n    // justify-content: space-between;\n  }\n\n  .wrapper_slider > div {\n    flex-grow: 1;\n  }\n\n  .MuiSlider-root {\n    order: -1;\n    margin: 0 10px;\n  }\n}\n\n.ant-input-number-affix-wrapper {\n  // :where(.css-dev-only-do-not-override-xu9wm8).ant-input-number-affix-wrapper {\n  background-color: #f7fafd;\n  position: relative;\n  // position: absolute;\n  // top: 0;\n  // left: 0;\n}\n\n.ant-input-number-prefix {\n  position: absolute;\n  left: 10px;\n  top: 50%;\n  z-index: 1;\n  transform: translateY(-50%);\n  font-size: 13px;\n  color: #757575;\n}\n\n.ant-input-number .ant-input-number-input {\n  // :where(.css-dev-only-do-not-override-xu9wm8).ant-input-number .ant-input-number-input {\n  // padding-left: 3px;\n  // padding-right: 3px;\n  padding: 3px;\n}\n\n.additional_filter__wrapper {\n  .filter-control-label {\n    // border-bottom: 1px solid #e3ecf5;\n    // padding-bottom: 14px;\n    color: #000;\n    width: 100%;\n    text-align: left;\n  }\n  button {\n    margin-bottom: 14px;\n    &[aria-expanded=\"true\"] {\n      border-bottom: 1px solid #e3ecf5;\n    }\n  }\n}\n\n.filter-img-black {\n  // filter: grayscale(100%) brightness(70%) contrast(301%);\n}\n\n.ant-checkbox-inner:after {\n  // :where(.css-dev-only-do-not-override-xu9wm8).ant-checkbox-indeterminate .ant-checkbox-inner:after {\n  background-color: var(--color-primary) !important;\n}\n\n.ant-checkbox-group {\n  // margin-top: 10px;\n}\n\n.house-3d-popover-action {\n  margin-right: auto;\n}\n\nsvg image {\n  pointer-events: visibleFill;\n}\n\n.filter-page__list-mode {\n  display: flex;\n  gap: 15px;\n  // margin-left: auto;\n}\n\n.filter-page__switch-mode {\n  // margin-right: auto;\n}\n// .compare-modal-content-body {\n//   .tag-card {\n//     right: auto;\n//     left: 0;po\n//   }\n// }\n\nhtml,\nbody {\n  overscroll-behavior-x: contain;\n}\n\n.ant-radio-wrapper,\n.ant-radio-wrapper:hover .ant-radio-inner,\n.ant-input-number:focus,\n.ant-input-number:focus-within {\n  border-color: var(--color-primary);\n}\n\n.ant-input-number:hover {\n  border-color: var(--color-primary);\n}\n\n.ant-input-number-affix-wrapper:hover,\n.ant-input-number-affix-wrapper:focus-within {\n  border-color: var(--color-primary);\n}\n\n.button-clean {\n  border: none;\n}\n\n.filter-page-house-dropdown {\n  background-color: #fff;\n  width: 100%;\n  padding: 10px 0;\n  // border: 1px solid #e9e8e8;\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n}\n\n.filter-page-house-select {\n  margin-top: 15px;\n  &__title {\n    display: block;\n    // margin-bottom: 10px;\n  }\n  button {\n    width: 100%;\n    text-align: left;\n    white-space: nowrap !important; /* Текст не переносится */\n    overflow: hidden; /* Обрезаем всё за пределами блока */\n    text-overflow: ellipsis !important; /* Добавляем многоточие */\n    // padding-right: 20px;\n    span {\n      display: inline !important;\n    }\n  }\n}\n\n.ant-btn-default:not(:disabled):not(.ant-btn-disabled):hover {\n  color: var(--color-primary) !important;\n  border-color: var(--color-primary) !important;\n}\n\n.svg-polygon-rooms-1 {\n  fill: var(--type_1_bg_color_static);\n  stroke: var(--type_1_color_stroke_static);\n  &:hover {\n    fill: var(--type_1_bg_color_hover);\n    stroke: var(--type_1_color_stroke_hover);\n  }\n}\n\n.svg-polygon-rooms-2 {\n  fill: var(--type_2_bg_color_static);\n  stroke: var(--type_2_color_stroke_static);\n  &:hover {\n    fill: var(--type_2_bg_color_hover);\n    stroke: var(--type_2_color_stroke_hover);\n  }\n}\n\n.svg-polygon-rooms-3 {\n  fill: var(--type_3_bg_color_static);\n  stroke: var(--type_3_color_stroke_static);\n  &:hover {\n    fill: var(--type_3_bg_color_hover);\n    stroke: var(--type_3_color_stroke_hover);\n  }\n}\n\n.svg-polygon-rooms-4 {\n  fill: var(--type_4_bg_color_static);\n  stroke: var(--type_4_color_stroke_static);\n  &:hover {\n    fill: var(--type_4_bg_color_hover);\n    stroke: var(--type_4_color_stroke_hover);\n  }\n}\n\n.svg-polygon-rooms-penthouse {\n  fill: var(--type_penthouse_bg_color_static);\n  stroke: var(--type_penthouse_color_stroke_static);\n  &:hover {\n    fill: var(--type_penthouse_bg_color_hover);\n    stroke: var(--type_penthouse4_color_stroke_hover);\n  }\n}\n\n.svg-polygon-rooms-studio {\n  fill: var(--type_studio_bg_color_static);\n  stroke: var(--type_studio_color_stroke_static);\n  &:hover {\n    fill: var(--type_studio_bg_color_hover);\n    stroke: var(--type_studio_color_stroke_hover);\n  }\n}\n\n.floor-builder-title {\n  font-size: 14px;\n}\n\n.ant-checkbox .ant-checkbox-input:focus-visible + .ant-checkbox-inner {\n  outline-color: transparent;\n}\n","@mixin respond($breakpoint) {\n  @if $breakpoint == big-desktop {\n    @media only screen and (min-width: 1920px) {\n      @content;\n    } //1000px\n  }\n\n  @if $breakpoint == desktop {\n    @media only screen and (min-width: 1600px) {\n      @content;\n    } //1000px\n  }\n  @if $breakpoint == laptop {\n    @media only screen and (min-width: 1200px) {\n      @content;\n    } //1440px\n  }\n  @if $breakpoint == tab {\n    @media only screen and (min-width: 768px) {\n      @content;\n    } //1000px\n  }\n  @if $breakpoint == mobile {\n    @media only screen and (min-width: 375px) {\n    }\n  }\n}\n\n@mixin reset-btn {\n  border: none;\n  background: none;\n  outline: none;\n  padding: 0;\n}\n\n@mixin horizont-scrollbar {\n  &::-webkit-scrollbar {\n    height: 3px;\n    background-color: #000000;\n  }\n  &::-webkit-scrollbar-thumb {\n    // background: var(--color-red);\n    background: #000000;\n  }\n}\n\n@mixin vertical-scrollbar {\n  &::-webkit-scrollbar {\n    width: 3px;\n    background: #000000;\n    border-radius: 2.5px;\n  }\n  &::-webkit-scrollbar-thumb {\n    border-radius: 2.5px;\n    background-color: #000000;\n  }\n}\n\n@mixin vertical-scrollbar-fancy {\n  &::-webkit-scrollbar {\n    width: 3px;\n    background: red;\n    border-radius: 2.5px;\n    visibility: hidden;\n  }\n  &::-webkit-scrollbar-thumb {\n    width: 3px;\n    border-radius: 2.5px;\n    background-color: #000000;\n  }\n}\n\n@mixin scaleHover {\n  img {\n    transition: transform 0.5s;\n    will-change: transform;\n  }\n  &:hover {\n    img {\n      transform: scale(1.1);\n    }\n  }\n}\n\n@mixin triangle {\n  position: relative;\n  &::before {\n    content: \"\";\n    width: 36px;\n    height: 18px;\n    position: absolute;\n    background-image: url(\"../assets/dialog-triangle-icon.svg\");\n    background-repeat: no-repeat;\n    background-size: contain;\n    z-index: -1;\n  }\n}\n\n@mixin triangleDark {\n  position: relative;\n  &::before {\n    content: \"\";\n    width: 36px;\n    height: 18px;\n    position: absolute;\n    background-image: url(\"../assets/dialog-triangle-dark-icon.svg\");\n    background-repeat: no-repeat;\n    background-size: contain;\n    z-index: -1;\n  }\n}\n\n@mixin hoverPrimaryLight {\n  @include respond(laptop) {\n    transition: color 0.25s;\n    &:hover {\n      color: #fff;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
